<template>
    <div class="">
        <b-spinner v-if="!answers"></b-spinner>
        <div v-if="answers && !answers.length">
            No forms completed yet.
        </div>
        <div class="" v-for="answer in answers">
          <h4>{{answer.question}}</h4>
          <p>{{answer.value}}</p>
        </div>
    </div>
</template>
<script>
import { ListAnswers } from '@/gql/members/Members.gql';

export default {
    props: {
        member: {
            type: Object,
            required: true
        }
    },
    apollo: {
        answers: {
            query: ListAnswers,
            variables () {
                return {
                    personId: this.member.id
                }
            }
        }
    }
}
</script>
